var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-promoGroups d-flex flex-column gap-1-5"},_vm._l((_vm.groups),function(group){return _c('promo-group',{key:`group-${group.id}`,attrs:{"group":group,"preview-type":_vm.previewType}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }